import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import { CommentContext, CommentContextProvider } from '../../CommentContext';
import LoadableCommentReduxModule from '../../redux/LoadableCommentReduxModule';
var View = /*#__PURE__*/ function(View) {
    /** The current user is editing one of their own comments. */ View["Editing"] = "editing";
    /** The comment has been marked as spam. */ View["Spam"] = "spam";
    /** The comment is hidden for some reason. Likely moderation */ View["Hidden"] = "hidden";
    /** Shown when the comment has been orphaned */ View["Orphan"] = "orphan";
    /** The usual view when nothing is wrong with the comment and the user isn't editing it. */ View["Read"] = "read";
    return View;
}(View || {});
/** Checks a couple flags and spits out the current view we should show for a comment. */ function getCommentView({ comment, isEditing, isPeeking }) {
    const { isSpam, isHidden, isDeleted, isAdminHidden, replies } = comment;
    const isVisible = !isAdminHidden && !isDeleted;
    if (isEditing) {
        return "editing";
    } else if (!isPeeking && isSpam && replies !== 0) {
        return "spam";
    } else if (!isPeeking && (isHidden || !isVisible) && replies !== 0) {
        return "hidden";
    } else if ((isHidden || !isVisible || isSpam) && !isPeeking) {
        return "orphan";
    } else {
        return "read";
    }
}
const CommentSkeletonViewSwitcher = ({ editingView, spamView, hiddenView, orphanView, readView })=>{
    const { comment } = useContext(CommentContext);
    const { isEditing, isPeeking } = useContext(CommentContext);
    const view = getCommentView({
        comment,
        isPeeking,
        isEditing
    });
    switch(view){
        // Fragments here because typescript complains otherwise.
        case "editing":
            return /*#__PURE__*/ React.createElement(React.Fragment, null, editingView);
        case "spam":
            return /*#__PURE__*/ React.createElement(React.Fragment, null, spamView);
        case "hidden":
            return /*#__PURE__*/ React.createElement(React.Fragment, null, hiddenView);
        case "orphan":
            return /*#__PURE__*/ React.createElement(React.Fragment, null, orphanView);
        case "read":
            return /*#__PURE__*/ React.createElement(React.Fragment, null, readView);
        default:
            return null;
    }
};
CommentSkeletonViewSwitcher.displayName = 'CommentSkeletonViewSwitcher';
/** A skeleton for the various views that a comment preset needs to implement. */ const CommentSkeleton = (_param)=>{
    var { comment, className, onEditingStateChange, extraActions } = _param, rest = _object_without_properties(_param, [
        "comment",
        "className",
        "onEditingStateChange",
        "extraActions"
    ]);
    return /*#__PURE__*/ React.createElement(CommentContextProvider, {
        comment: comment,
        onEditingStateChange: onEditingStateChange,
        extraActions: extraActions
    }, /*#__PURE__*/ React.createElement(LoadableCommentReduxModule, null), /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement(CommentSkeletonViewSwitcher, rest)));
};
CommentSkeleton.displayName = 'CommentSkeleton';
export default CommentSkeleton;

//# sourceMappingURL=CommentSkeleton.js.map